function ngsUploadImageFIle(e) {
    let t = document.getElementById("upload").files[0]
      , n = document.querySelector(".product__media")
      , i = n.querySelector(".upload-block");
    if (i && i.remove(),
    t) {
        let s = new FileReader;
        s.onload = function(i) {
            let s = t.type.split("/")[0];
            if ("image" === s) {
                let a = document.createElement("div");
                a.className = "upload-block",
                a.id = "upload-block";
                let l = document.createElement("img");
                l.src = i.target.result,
                l.id = "ngs-uploaded-img",
                l.alt = "Uploaded Image",
                l.style.height = "100%",
                "" != e ? (a.style.cssText = e,
                l.style.width = "100%") : l.style.maxWidth = "100%",
                a.appendChild(l),
                n.appendChild(a)
            } else
                alert("The selected file is not an image.")
        }
        ,
        s.readAsDataURL(t)
    } else
        alert("No file selected.")
}
document.addEventListener("DOMContentLoaded", async function() {
    !("qqx2gb-w1.myshopify.com" == Shopify.Shop || window.location.href.includes("carpetplanet.in") || window.location.href.includes("carpetplanet.co")) && window.location.pathname.includes("/products/") && await e();
    async function e() {
        let e = !1;
        var t = "";
        let n = document.getElementById("ngs-image"), i = document.getElementById("ngs-selection"), s = document.getElementById("ngs-width-input"), a = document.getElementById("ngs-height-input"), l = document.getElementById("ngs-preview-btn"), r = document.getElementById("ngs-preview"), o = document.getElementById("ngs-mirror-toggle"), u = document.querySelector(".ngs-container"), d = document.getElementById("ngs-measure_type"), c = document.querySelector(".ngs-top-image-repeat"), p = null, g = !1, m = null, h, f, y, v, w, _, b = !1, x = !1, E = !1, S = "", q = window.location.origin, I = Shopify.shop, T = null, C = !1, L = null, M = 0, B = 0, k = 0, R = !1, P = !1, z = 0, H = 0, A = 0, F = 0, N = null, j = null, D = null, U = null, W = 0, O = 0, V = 0, X = 0, Y = "", Q = "https://customsizeprices.com/apps/", G = {
            "ngs-top-center": ["top"],
            "ngs-bottom-center": ["bottom"],
            "ngs-left-center": ["left"],
            "ngs-right-center": ["right"]
        }, Z = [80, 90, 100, 120, 130, 140];
        var J = []
          , K = "";
        let ee = !1;
        function et(e, t, n, i) {
            let s = 0;
            return s = e / t > n / i ? n / e : i / t,
            {
                width: e *= s,
                height: t *= s
            }
        }
        function en() {
            let e = parseInt(s.value)
              , t = parseInt(a.value);
            var n = 410;
            e *= 37.795275591,
            t *= 37.795275591;
            var i, l = 820, r = 410;
            screen.width < 820 && (l = screen.width,
            e > t && (r = screen.width + 15));
            var o = 410 * e / t
              , u = (i = 45 * (n = o > l ? l / o * r : r),
            37.795275591 * i / t);
            let d = document.querySelector(".ngs-top-image-repeat");
            d.style.width = `${o}px`,
            d.style.height = `${n}px`,
            m.style.backgroundSize = u + "px"
        }
        function ei(e) {
            P = !0,
            z = e,
            A = H,
            document.body.style.userSelect = "none"
        }
        function es(e) {
            if (!P)
                return;
            let t = e - z
              , n = A + t;
            H = Math.min(0, n),
            p.style.backgroundPositionX = `${H}px`
        }
        function ea() {
            P = !1,
            document.body.style.userSelect = ""
        }
        function el() {
            "0" != j.isImageVisualiser && (!1 == g && (function e() {
                (c = document.querySelector(".ngs-top-image-repeat")) && (p = c.querySelector(".ngs-actual-image-repeat")),
                m = document.querySelector(".ngs-grid-panel-lines");
                let t = new Image;
                t.src = S,
                t.onload = function() {
                    t.naturalWidth,
                    t.naturalHeight;
                    let e = e => 37.795275591 * e;
                    window.addEventListener("load", function t() {
                        let n = parseInt(s.value)
                          , i = parseInt(a.value)
                          , l = e(n)
                          , r = e(i);
                        l = Math.min(l, 820),
                        r = Math.min(r, 410),
                        c.style.width = `${l}px`,
                        c.style.height = `${r}px`,
                        p.style.backgroundImage = `url(${imageUrl})`,
                        en()
                    })
                }
            }(),
            g = !0),
            en())
        }
        function er() {
            if ("0" == j.isImageVisualiser)
                return;
            let e = parseInt(s.value, 10)
              , t = parseInt(a.value, 10);
            if (isNaN(e) || isNaN(t))
                return;
            let l = n.getBoundingClientRect(), r = n.parentElement.getBoundingClientRect(), o = e / t, u, d;
            o > l.width / l.height ? d = (u = l.width) / o : u = (d = l.height) * o,
            u = Math.min(u, r.width),
            d = Math.min(d, r.height),
            i.style.width = `${u}px`,
            i.style.height = `${d}px`,
            i.style.left = "0px",
            i.style.top = "0px",
            i.style.display = "block",
            eu()
        }
        function eo(e) {
            e.preventDefault();
            let t = "touchstart" === e.type
              , l = t ? e.touches[0].clientX : e.clientX
              , r = t ? e.touches[0].clientY : e.clientY;
            function o(e) {
                if (!x)
                    return;
                let t = "touchmove" === e.type ? e.touches[0].clientX : e.clientX, l = "touchmove" === e.type ? e.touches[0].clientY : e.clientY, r = n.parentElement.getBoundingClientRect(), o = i.getBoundingClientRect(), u, d, c = t - h, p = l - f, g = o.width >= r.width, m = o.height >= r.height;
                g && m && (R ? m = !1 : g = !1),
                g ? (d = Math.min(Math.max(_ + p, 50), r.height - (parseInt(i.style.top, 10) || 0)),
                u = w) : m ? (u = Math.min(Math.max(w + c, 50), r.width - (parseInt(i.style.left, 10) || 0)),
                d = _) : (u = Math.min(Math.max(w + c, 50), r.width - (parseInt(i.style.left, 10) || 0)),
                d = Math.min(Math.max(_ + p, 50), r.height - (parseInt(i.style.top, 10) || 0))),
                u = Math.min(u, r.width - (parseInt(i.style.left, 10) || 0)),
                d = Math.min(d, r.height - (parseInt(i.style.top, 10) || 0)),
                i.style.width = `${u}px`,
                i.style.height = `${d}px`,
                s.value = parseInt(i.style.width, 10),
                a.value = parseInt(i.style.height, 10)
            }
            function u(e) {
                e.preventDefault(),
                x = !1,
                document.removeEventListener("mousemove", o),
                document.removeEventListener("mouseup", u),
                document.removeEventListener("touchmove", o),
                document.removeEventListener("touchend", u),
                eu()
            }
            h = l,
            f = r,
            w = parseInt(document.defaultView.getComputedStyle(i).width, 10),
            _ = parseInt(document.defaultView.getComputedStyle(i).height, 10),
            x = !0,
            document.addEventListener("mousemove", o),
            document.addEventListener("mouseup", u),
            document.addEventListener("touchmove", o),
            document.addEventListener("touchend", u)
        }
        function eu() {
            let e = n.parentElement.getBoundingClientRect()
              , t = i.getBoundingClientRect()
              , l = t.width >= e.width
              , r = t.height >= e.height;
            l || r || (s > a ? l = !0 : r = !0),
            l && r && (R ? l = !1 : r = !1),
            Object.keys(G).forEach(e => {
                let t = i.querySelector(`.${e}`);
                null != t && (t.style.display = "none")
            }
            ),
            Object.keys(G).forEach(n => {
                let s = i.querySelector(`.${n}`);
                null != s && (l ? (R = !0,
                n.includes("ngs-top-center") || n.includes("ngs-bottom-center") ? s.style.display = "block" : s.style.display = "none") : r && (t.height >= e.height ? (R = !1,
                n.includes("ngs-left-center") || n.includes("ngs-right-center") ? s.style.display = "block" : s.style.display = "none") : n.includes("ngs-top-center") || n.includes("ngs-bottom-center") ? s.style.display = "block" : s.style.display = "none"))
            }
            )
        }
        function ed() {
            if ("0" == j.isImageVisualiser)
                return;
            let e = n.getBoundingClientRect()
              , t = i.getBoundingClientRect()
              , s = n.parentElement.getBoundingClientRect()
              , a = n.naturalWidth / e.width
              , l = n.naturalHeight / e.height
              , r = (t.left - s.left) * a
              , o = (t.top - s.top) * l
              , u = t.width * a
              , d = t.height * l;
            return n.classList.contains("mirror") && (r = n.naturalWidth - r - u),
            {
                x: r,
                y: o,
                width: u,
                height: d
            }
        }
        function ec() {
            "0" != j.isImageVisualiser && "0" != j.isImageCrop && (n.crossOrigin = "Anonymous",
            K = ep(n.src),
            n.onload = function() {
                let {x: e, y: t, width: i, height: s} = ed()
                  , a = document.createElement("canvas");
                a.width = i,
                a.height = s;
                let l = a.getContext("2d");
                n.classList.contains("mirror") && (l.translate(i, 0),
                l.scale(-1, 1)),
                function e(t) {
                    if ("0" === j.filtersRequired)
                        return;
                    let n = document.querySelector(".ngs-filter-option:checked")?.value || "none";
                    t.filter = n
                }(l),
                l.drawImage(n, e, t, i, s, 0, 0, a.width, a.height),
                r.src = a.toDataURL(K, .2),
                function e(t) {
                    let n = window.innerWidth
                      , i = window.innerHeight;
                    t.onload = function() {
                        let e = t.naturalWidth / t.naturalHeight;
                        e > n / i ? (t.style.width = "100%",
                        t.style.height = "auto") : (t.style.width = "auto",
                        t.style.height = "100%")
                    }
                }(r)
            }
            ,
            n.onerror = function() {
                console.error("Error loading image.")
            }
            ,
            n.complete && n.onload())
        }
        function ep(e) {
            let t = e.split(".").pop().split(/[\?#]/)[0];
            switch (t) {
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
            default:
                return "image/png";
            case "webp":
                return "image/webp";
            case "tif":
            case "tiff":
                return "image/tiff"
            }
        }
        function eg() {
            n.classList.contains("mirror") ? (n.classList.remove("mirror"),
            o.textContent = "Mirror Off") : (n.classList.add("mirror"),
            o.textContent = "Mirror On"),
            ec()
        }
        function em() {
            if (j?.isSetQuantity != "1") {
                if ("0" == j.isImageCrop)
                    return el();
                if (null != n && n.complete) {
                    let e = n.naturalWidth
                      , t = n.naturalHeight
                      , i = window.innerWidth;
                    window.innerHeight;
                    let s = e / t, a, l;
                    if (i <= 1024)
                        (l = Math.floor((a = Math.floor(.95 * i)) / s)) > 300 && (a = Math.floor((l = 300) * s));
                    else {
                        let r = document.querySelector(".ngs-controls")
                          , o = Math.min(r.offsetWidth, 400)
                          , d = document.querySelector(".ngs-wrapper").offsetWidth;
                        "papierpeint.myshopify.com" == I && (o = Math.min(r.offsetWidth, 500)),
                        (l = Math.floor((a = Math.floor(d - o - 20)) / s)) > 590 && (a = Math.floor((l = 590) * s))
                    }
                    u.style.maxWidth = `${a}px`,
                    u.style.height = `${l}px`,
                    er()
                } else
                    n.addEventListener("load", em)
            }
        }
        function eh() {
            let e = "";
            if ("1" == j.isImageVisualiser) {
                let t = "file";
                "1" == j.isImageExternal && (t = "hidden"),
                e = `
            <div class="ngs-upload-div">
                <label for="ngs-photo">Upload Photo</label>
                <input required=""  id="ngs-photo" type="${t}" name="properties[Selected Image]">
                
            </div>
            `
            }
            let n = "";
            "1" == j.splNotesRequired && (n = ` <input id="ngs_custom_spl_notes" type="hidden" name="properties[${j.splNotesText}]" 
            value="">`);
            let i = "";
            return "1" == j.isShapesRequired && (j.shapeText = "Shape:",
            i = ` <input id="ngs_shape_type" type="hidden" name="properties[${j.shapeText}]" 
            value="">`),
            ` <div>
        <input id="ngs_custom_final_price" type="hidden" name="properties[__ngs_customPrice]" 
        value="0">
        <input id="ngs_custom_price_product_text" type="hidden" name="properties[__ngs_customPriceProductText]" 
        value="${j.customPriceProductText}">
        <input id="ngs_product_base_price" type="hidden" name="properties[__ngs_productBaseCurrencyPrice]" 
        value="0">
        <input id="ngs_original_currency" type="hidden" name="properties[__ngs_originalCurrency]" 
        value="0">
        <input id="ngs_custom_final_custom_size" type="hidden" name="properties[${j.sizeText}]" 
                value="0">
        <input id="ngs_all_properties_data" type="hidden" name="properties[__ngs_all_properties_data]" 
                value="">
                ${i}
        </div> ${e} ${n}`
        }
        function ef(e) {
            return `
                <select id="ngs-${e}-sub-inches" class="ng-sub-inch-select" >
                    <option value="0" disabled selected hidden>inch</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                </select>
           `
        }
        function ey(e) {
            let t = e.toString();
            if (t.includes(".")) {
                let n = t.split(".");
                if ("0" === n[1] || "00" === n[1] || "000" === n[1])
                    return n[0]
            }
            return t
        }
        function ev(e, t) {
            e.widthText = j.mainWidthText,
            e.heightText = j.mainHeightText,
            t = ew(t),
            "1" === j.isDisplayMeasurementTypeInTop && (e.widthText = `${e.widthText}(${ew(t)})`,
            e.heightText = `${e.heightText}(${ew(t)})`)
        }
        function e$(e, t, n) {
            let i = document.getElementById(e)
              , s = parseFloat(i.value);
            s < t ? t > 0 && (i.value = t) : s > n && n > 0 && (i.value = n),
            "0" == j.isImageCrop && el(),
            ta()
        }
        function ew(e) {
            return 0 === e.length ? e : e.charAt(0).toUpperCase() + e.slice(1)
        }
        function e_() {
            var t, n, i, s, a, l, r, o;
            let u = j.measurementTypes.split(",")
              , d = ""
              , c = ""
              , p = "";
            if ("1" == j.isShapesRequired && (p = `<select id="ngs-shape-type">
                                   <option value="rectangle" >Rectangle</option>
                                   <option value="square" >Square</option>
                                   <option value="round" >Round</option>
                                 </select>`),
            u.length > 1) {
                Y = j.defaultMeasurementType,
                d = "display:inline-block";
                let g = u[0].trim().toLowerCase()
                  , m = u[1].trim().toLowerCase()
                  , h = {
                    cm: "cm",
                    inch: "Inch",
                    m: "Meters",
                    ft: "Feet"
                };
                "t" == j.multiMeasurementType && (c = `
                            <div class="ngs-tog-measure-unit">
                                <div tabindex="0" class="ngs-msr">${h[g] || g}</div> 
                                <span data-current-value="${g}" class="ngs-measure-unit-toggle toggle"></span> 
                                <div tabindex="0" class="ngs-msr">${h[m] || m}</div>
                            </div>`)
            }
            let f = "";
            u.some(e => e.toLowerCase() === j.defaultMeasurementType.toLowerCase()) || u.push(j.defaultMeasurementType);
            for (let y = 0; y < u.length; y++) {
                if ("" == u[y])
                    continue;
                let v = "";
                j.defaultMeasurementType.toLowerCase() == u[y].toLowerCase() && (v = "selected"),
                f += ` <option ${v} value="${u[y]}">${ew(u[y])}</option>`
            }
            let w = "";
            "sq ft" == j.priceUnitType ? w = "ft<sup>2</sup>" : "sq meter" == j.priceUnitType && (w = "m<sup>2</sup>");
            let _ = "";
            "1" == j.splNotesRequired && (_ = ` <div class="ngs-input-other-item ngs-spl-notes">
                                <label for=""ngs-instructions">${j.splNotesText}</label>
                                <textarea id="ngs-spl-instructions" ></textarea>
                            </div>`);
            let b = "";
            "1" == j.instructionRequired && (b = `<div class="ngs-input-other-item ngs-div-instructions">
                    <label id="ngs-instructions">${j.instructionsContent}</label>
                </div>`);
            let x = "";
            "1" == j.isTotalMeasurementsRequired && (x = `<div class="ngs-input-other-item ngs-div-totalMeasurement">
            <label >${j.totalMeasurementText}
    
            <span id="ngs-total-measurement-value"></span> 
            </label>
                </div>`);
            let E = ` <div class="ngs-input-other-item ngs-final-price ">
          <label >${j.totalText} <span id="ngs-final-price">${tl(0)}</span></label>
        </div>
      <div class="ngs-input-other-item ngs-actual-price">
          <label>(<span id="ngs-measure-price">${tl(B)}/ ${w}</span>)  </label>
      </div>`;
            "1" == j.isTotalSingleLine && (E = ` <div class="ngs-input-other-item ngs-total-section">
        <label >${j.totalText} <span id="ngs-final-price"> ${tl(0)}</span>
    
        <span id="ngs-measure-price">(${tl(B)}/ ${w})</span> 
        </label>
        </div>`);
            let S = "";
            "fc28f4-d9.myshopify.com" == I && (S = '<div class="ngs-in-above-text">PERSONALIZZA LA TUA MISURA</div>');
            let q = "";
            "d" == j.multiMeasurementType && (q = "display:inline-block");
            let T, C, L, M, k, R, P, z, H, A, F, N;
            return `  ${T = "",
            j.headerText.trim().length > 0 && (T = `<div class="ngs-top-header">${j.headerText.trim()}</div>`),
            j.headerDescription.trim().length > 0 && (T = `${T}<div class="ngs-top-header-desc">${j.headerDescription.trim()}</div>`),
            T.length > 0 && (T = `<div class="ngs-main-top-header">${T}</div>`),
            T}
                    ${function t() {
                if (0 === U.length)
                    return "";
                let n = '<div class="ngs-preset-container" id="ngs-preset-container">';
                return e ? (n += Z.map(e => `
                    <button class="ngs-preset-button">${e}</button>
                `).join(""),
                n += "</div>") : (n += U.map(e => `
                <button class="ngs-preset-button">${e.width} X ${e.height}</button>
            `).join(""),
                n += "</div>")
            }()}
                    ${S}
                    ${p}
                    <div class="ngs-input-group "  style="${q}">
                    <div class="ngs-input-group-item ngs-measure-sec"  >
                        <label for="ngs-measure_type">${j.measureTypeText}</label>
                        <select id="ngs-measure_type" class="ngs-measure_types">

                            ${f}
                        </select>
                    </div>
                  
                   
                </div>
                ${c}
                ${C = "",
            L = j.defaultHeightValue,
            ("D" === j.shapeType || "S" === j.shapeType || "1" === j.inputBoxes) && (C = "display:none"),
            ev(M = {
                widthText: "",
                heightText: ""
            }, j.defaultMeasurementType),
            widthValue = Math.max(W = "1" === D.isMinSizeEnable ? D.minWidth : 0, Math.min(O = "1" === D.isMaxSizeEnable ? D.maxWidth : 1 / 0, j.defaultWidthValue)),
            L = Math.max(V = "1" === D.isMinSizeEnable ? D.minHeight : 0, Math.min(X = "1" === D.isMaxSizeEnable ? D.maxHeight : 1 / 0, L)),
            1 == j.inputBoxes && (L = 1),
            k = "",
            R = "",
            "1" == D.isMinSizeEnable && (D.minWidth > 0 && (k = `Min:${W}`),
            D.minHeight > 0 && (R = `Min:${V}`)),
            "1" == D.isMaxSizeEnable && (D.maxWidth > 0 && (k = `${k} Max:${O}`),
            D.maxHeight > 0 && (R = `${R} Max:${X}`)),
            P = "",
            "1" == j.showSideMeasures && (P = "ngs-side-measure-textbox"),
            z = "",
            "1" == j.placeHoldersRequired && (z = j.defaultMeasurementType.toLowerCase()),
            H = ` <input id="ngs-width-input" type="number" step="0.01" min="0" value="${widthValue}" class="ngs-dimension-input ${P}" placeholder="${z}"
        />`,
            A = `  <input id="ngs-height-input" type="number"  step="0.01" min="0" value="${L}" class="ngs-dimension-input ${P}"  placeholder="${z}"
        />`,
            "the-rugs-4968.myshopify.com1" == I && (H = `
                        <select id="ngs-width-input" class="ngs-dimension-input ${P}">
                        <option value="100" selected >100</option>
                        <option value="200" >200</option>
                        </select>
                    `),
            "0" == j.doNotDisplayValues && (H = ` <input id="ngs-width-input" type="number" min="0" step="0.01"  class="ngs-dimension-input ${P}" placeholder="${z}"/>`,
            A = ` <input id="ngs-height-input" type="number" min="0" step="0.01"  class="ngs-dimension-input ${P}"  placeholder="${z}" />`),
            "1" == j.showSideMeasures && (H += ' <span class="ngs-side-measure">cm</span>',
            A += ' <span class="ngs-side-measure">cm</span>'),
            F = "",
            ["babiesdecor.myshopify.com", "graffitiwallart.myshopify.com", "a9a8a0-3.myshopify.com", "834cf9-4.myshopify.com"].includes(I) && (F = '<p class="ngs-trim-text">Add extra  <span class="ngs-trim-value">5cm</span>  for coverage</p>'),
            N = "",
            (j?.isSetQuantity == "1" && (N = `
            <button  class="ngs-calculate-tiles-button">Calculate</button>
    
            <div class="ngs-tiles-container"  style="display: none;">
              <div class="tiles-calculate-box">
                <span class="ngs-tiles-label">Exact quantity:</span>
                <span  class="ngs-tiles-value ngs-exact-quantity-value"></span>
              </div>
              <div class="tiles-calculate-box">
                <span class="ngs-tiles-label">With 10% cutting waste:</span>
                <span class="ngs-tiles-value ngs-with-waste-value"></span>
              </div>
          </div>`),
            "1" == j.isInchesRequired) ? (H = ` <input id="ngs-width-input" type="number" min="0" step="1"  class="ngs-main-feet-input ngs-dimension-input ${P}" placeholder="${z}"/> ${ef("width")}`,
            A = ` <input id="ngs-height-input" type="number" min="0" step="1"  class="ngs-main-feet-input ngs-dimension-input ${P}"  placeholder="${z}" /> ${ef("height")}`,
            t = M,
            n = H,
            i = k,
            s = C,
            a = A,
            l = R,
            r = N,
            `
            <div class="ngs-row">
                <div class="ngs-column ngs-main-feet-column">
                    <div class="ngs-dimension-main-input-group">
                        
                        <!-- Header Row -->
                        <div class="ngs-dimension-input-header-row" style="display: flex; gap: 10px;">
                            <div class="ngs-dimension-title ngs-width-title" style="flex: 1;">${t.widthText}</div>
                            <div class="ngs-dimension-title ngs-dimension-title-sub-inch" style="flex: 1;display:none">Inches</div>
                        </div>
                        
                        <!-- Input Row -->
                        <div class="ngs-dimension-input-row" style="display: flex; gap: 10px;">
                            ${n}
                        </div>
                        
                        <p class="ngs-width-min-max ngs-min-max">
                            ${i} ${j.defaultMeasurementType.toLowerCase()}
                        </p>
                    </div>
                </div>
    
                <div class="ngs-column ngs-main-feet-column" style="${s}">
                    <div class="ngs-dimension-main-input-group ngs-right-side">
                        
                        <!-- Header Row -->
                        <div class="ngs-dimension-input-header-row" style="display: flex; gap: 10px;">
                            <div class="ngs-dimension-title ngs-height-title" style="flex: 1;">${t.heightText}</div>
                            <div class="ngs-dimension-title ngs-dimension-title-sub-inch " style="flex: 1;display:none">Inches</div>
                        </div>
                        
                        <!-- Input Row -->
                        <div class="ngs-dimension-input-row" style="display: flex; gap: 10px;">
                            ${a}
                        </div>
                        
                        <p class="ngs-height-min-max ngs-min-max">
                            ${l} ${j.defaultMeasurementType.toLowerCase()}
                        </p>
                    </div>
                </div>
            </div>
            ${r}
            ${o = F}
        `) : `
            <div class="ngs-row">
                <div class="ngs-column">
                    <div class="ngs-dimension-main-input-group">
                        <div class="ngs-dimension-input-group">
                            <div for="ngs-width-input" class="ngs-dimension-title ngs-width-title">${M.widthText}</div>
                           ${H}
                        </div>
                        <p class="ngs-width-min-max ngs-min-max">${k} ${j.defaultMeasurementType.toLowerCase()}</p>
                    </div>
                </div>
    
                <div class="ngs-column" style="${C}">
                    <div class="ngs-dimension-main-input-group ngs-right-side">
                        <div class="ngs-dimension-input-group">
                            <div for="ngs-height-input" class="ngs-dimension-title ngs-height-title">${M.heightText}</div>
                           ${A}
                        </div>
                        <p class="ngs-height-min-max ngs-min-max">${R} ${j.defaultMeasurementType.toLowerCase()}</p>
                    </div>
                </div>
            </div>
            ${N}
            ${F}
        `}
                ${x}
                ${E}
                ${_}
                ${b}
  `
        }
        function eb() {
            if ("1" == j.isInlineUpload)
                return `
                <input type="button" required id="ngs-upload-fake" value="Upload your image" style="width:100%" />
                <input required="" class="required" id="ngs-upload" type="file"  style="display:none"
                name="properties[upload]" >`;
            if (E) {
                if ("1" == j.isCustomImageFileUpload && "1" == j.uploadImageAsMainImage)
                    return `<input required="" class="required" id="upload" type="file" 
                    name="properties[upload]" onchange="ngsUploadImageFIle('${D.imageCss}')">`;
                if ("1" == j.isCustomImageFileUpload)
                    return `<input required="" class="required" id="upload" type="file" 
                    name="properties[upload]" >`
            } else {
                if ("1" == j.isCustomImageFileUpload && "1" == j.uploadImageAsMainImage)
                    return `
                    <input type="button" id="ngs-upload-fake" value="Upload your image"  />
                    <input required="" class="required" id="ngs-upload" type="file"  style="display:none"
                    name="properties[upload]" >`;
                if ("1" == j.isCustomImageFileUpload)
                    return `<input required="" class="required" id="ngs-upload" type="file" 
                    name="properties[upload]" >`
            }
            return ""
        }
        function ex(e) {
            let t = document.createElement("div");
            t.innerHTML = eh(),
            e.appendChild(t)
        }
        async function eE() {
            return eS()
        }
        async function eS() {
            let e = document.querySelectorAll(".ngs-main-rows");
            F = 0;
            let t = 1
              , n = 0
              , i = 0;
            if (e.forEach(e => {
                let s = parseFloat(e.value) || 0;
                0 == s ? t = 0 : (n += s,
                i += 1)
            }
            ),
            0 == t)
                return document.querySelector(".ngs-multi-total").textContent = ` €-`,
                !1;
            let s = document.querySelectorAll(".ngs-new-add-rows")
              , a = !0;
            s.forEach(e => {
                let t = parseFloat(e.value) || 0;
                0 == t ? a = !1 : (n += t,
                i += 1)
            }
            );
            let l, r;
            return F = (44.5 + (n * (B / 270) + 1.12 * i)) * 2.21,
            document.querySelector(".ngs-multi-total").textContent = function e(t, n=!1, i=!0) {
                let s = new Intl.NumberFormat("de-DE",{
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(t)
                  , a = i ? " " : "";
                return n ? `€${a}${s}` : `${s}${a}€`
            }(F.toFixed(2), !0, !1),
            a
        }
        function e9() {
            return "" != D.isPopup && (j.isPopup = D.isPopup),
            "0" == j.isPopup
        }
        function eq(e, t=!1) {
            let n = "ngs-spinner";
            t && (n = "ngs-spinner-sample");
            let i = e.querySelector("." + n);
            i && i.remove();
            let s = e.querySelector(".ngs-button-text");
            s && (s.style.visibility = "visible"),
            e.classList.remove("ngs-button-loading")
        }
        function eI(e, t=!1) {
            let n = "ngs-spinner";
            if (!0 == t && (n = "ngs-spinner-sample"),
            !e.querySelector("." + n)) {
                let i = document.createElement("div");
                i.innerText = "",
                i.className = n,
                e.appendChild(i)
            }
            let s = e.querySelector(".ngs-button-text");
            s && (s.style.visibility = "hidden"),
            e.classList.add("ngs-button-loading")
        }
        async function eT() {
            let e = parseFloat(B);
            document.getElementById("ngs_custom_final_price").value = F.toFixed(2),
            document.getElementById("ngs_product_base_price").value = e.toFixed(2);
            try {
                let t = (F / Shopify.currency.rate).toFixed(2);
                document.getElementById("ngs_custom_final_price").value = t,
                document.getElementById("ngs_product_base_price").value = (e / Shopify.currency.rate).toFixed(2),
                document.getElementById("ngs_original_currency").value = Shopify.currency.active
            } catch (n) {}
            if ("1" == j.isShapesRequired && (document.getElementById("ngs_shape_type").value = document.querySelector("#ngs-shape-type").value),
            document.getElementById("ngs_custom_final_custom_size").value = tb(),
            "1" == j.splNotesRequired && (document.getElementById("ngs_custom_spl_notes").value = document.getElementById("ngs-spl-instructions").value),
            "1" == j.isImageVisualiser && "0" == j.isImageCrop) {
                await e4();
                return
            }
            await eU()
        }
        function eC() {
            document.getElementById("ngs-add-to-cart").addEventListener("click", async function(t) {
                if (t.preventDefault(),
                j?.isSetQuantity == "1") {
                    eI(this, !1),
                    document.querySelector('[name="quantity"]').value = document.querySelector(".ngs-with-waste-value").textContent,
                    document.querySelector('[name="add"]').click(),
                    e8(this);
                    return
                }
                if ("1" == j.isInlineUpload) {
                    let n = document.getElementById("ngs-upload");
                    if (!n.files.length) {
                        alert("Please upload an image before adding to cart.");
                        return
                    }
                    eI(this, !1),
                    null != document.querySelector('[name="add"]') ? (document.querySelector('[name="add"]').click(),
                    eq(this, !1)) : null != document.querySelector(".shopify-product-form") ? (document.querySelector(".shopify-product-form").submit(),
                    eq(this, !1)) : N.submit();
                    return
                }
                if (ta(!1),
                "1" == j.isMultiInputs && await eE() == !1) {
                    alert("Voer geldige waarden in");
                    return
                }
                if (!1 == C) {
                    if (isNaN(F))
                        return alert("Please enter numeric values only"),
                        !1;
                    if (!0 == function e() {
                        var t = !1
                          , n = `<span class="bold_error_message">
                              <small>This option is required.</small>
                            </span>`;
                        if ("test.myshopify.com" == I) {
                            for (var i = 0; i < J.length; i++) {
                                var s = `[name="properties[${J[i]}]"]`
                                  , a = document.querySelectorAll(s);
                                a.length > 0 && "" == a[0].value && (t = !0,
                                null === document.querySelector(".hulkapps_option_value .bold_error_message")) && (document.querySelector(".hulkapps_option_child").insertAdjacentHTML("afterend", n),
                                document.querySelector(".bold_error_message").style.color = "red")
                            }
                            return t
                        }
                        for (var i = 0; i < J.length; i++) {
                            var s = `[name="properties[${J[i]}]"]`
                              , a = document.querySelectorAll(s);
                            a.length > 0 && ("" == a[0].value ? (t = !0,
                            document.querySelectorAll(".bold_option_title").forEach(function(e) {
                                if (e.innerHTML == J[i] + "*") {
                                    var t = e.parentElement;
                                    t.classList.contains("bold_option_error") || (t.classList.add("bold_option_error"),
                                    t.insertAdjacentHTML("beforeend", n))
                                }
                            })) : document.querySelectorAll(".bold_option_title").forEach(function(e) {
                                if (e.innerHTML == J[i] + "*") {
                                    var t = e.parentElement;
                                    if (t.classList.contains("bold_option_error")) {
                                        t.classList.remove("bold_option_error");
                                        var n = t.querySelector(".bold_error_message");
                                        n && n.remove()
                                    }
                                }
                            }))
                        }
                        return t
                    }())
                        return;
                    let i = Math.floor(100 * F) / 100;
                    if (D.minOrder > 0 && i < D.minOrder) {
                        alert(`Minimum order value is ${j.priceSymbol} ${D.minOrder}`);
                        return
                    }
                    if (i <= 0) {
                        e ? alert("Please enter diameter") : alert("The minimum order value should be greater than zero.");
                        return
                    }
                }
                eI(this, !1),
                "1" == j.isImageVisualiser && "1" == j.isImageCrop && await ec(),
                setTimeout(async () => {
                    if ("1" == j.isCartTransformer) {
                        await eT();
                        let e, t;
                        if (document.querySelector('form[action="/cart/add"]'),
                        e = {},
                        t = ["__ngs_all_properties_data", "__ngs_customPriceProductText", "__ngs_productBaseCurrencyPrice", "__ngs_originalCurrency"],
                        document.querySelectorAll("input[name^='properties[']").forEach(n => {
                            let i = n.name.match(/properties\[(.*?)\]/)[1]
                              , s = "file" === n.type ? n.files[0]?.name || "No file" : n.value;
                            t.includes(i) || (e[i] = s)
                        }
                        ),
                        document.getElementById("ngs_all_properties_data").value = JSON.stringify(e, null, 2),
                        "" != j.addToCartButtonClick) {
                            document.querySelector(j.addToCartButtonClick).click(),
                            e8(this);
                            return
                        }
                        null != document.querySelector('[name="add"]') ? (document.querySelector('[name="add"]').click(),
                        e8(this)) : null != document.querySelector(".shopify-product-form") ? (document.querySelector(".shopify-product-form").submit(),
                        e8(this)) : N.submit();
                        return
                    }
                    let n = ""
                      , i = null;
                    if ("1" == j.isImageVisualiser && "1" == j.isImageCrop) {
                        let s = eP();
                        if (s.length > 0) {
                            let a = ez(s, K);
                            eM(i = await a.arrayBuffer()) ? await eB(n = eL(), i) : n = "-1"
                        }
                    } else if ("1" == j.uploadImageAsMainImage) {
                        let l = function e() {
                            let t = document.getElementById("ngs-uploaded-img");
                            if (null == t)
                                return "";
                            let n = t.src.split(",")[1];
                            return n = n.replace(/^data:image\/\w+;base64,/, ""),
                            K = ep(t.src),
                            n
                        }();
                        if (l.length > 0) {
                            let r = ez(l, K);
                            eM(i = await r.arrayBuffer()) ? await eB(n = eL(), i) : n = "-1"
                        }
                    }
                    var o = await eH(n, i);
                    if ("1" == o.statusCode) {
                        await e6(o);
                        return
                    }
                    alert("Error"),
                    button.classList.remove("ngs-button-loading");
                    let u = button.querySelector(".ngs-button-text");
                    u || ((u = document.createElement("span")).className = "ngs-button-text",
                    u.textContent = "Add To Cart",
                    button.appendChild(u)),
                    u.style.visibility = "visible";
                    let d = button.querySelector(".ngs-spinner");
                    d && button.removeChild(d)
                }
                , 100)
            })
        }
        function e8(e) {
            E || function e(t=0, n=5) {
                if (t >= n) {
                    console.log("Max attempts reached.");
                    return
                }
                setTimeout(async () => {
                    console.log(`Attempt ${t + 1} of ${n}`);
                    let i = await tS();
                    if (i > M) {
                        if (M = i,
                        console.log("Cart updated, redirecting..."),
                        "1" == j.isOpenCartDrawer)
                            return;
                        window.location.assign(q + "/cart")
                    } else
                        e(t + 1, n)
                }
                , 300)
            }(0, 5),
            setTimeout( () => {
                eq(e, !1)
            }
            , 1e3)
        }
        function eL() {
            return "xxxx-xxxx-xxxx-xxxx".replace(/[x]/g, function() {
                return (16 * Math.random() | 0).toString(16)
            })
        }
        function eM(e) {
            return e.byteLength > 1048576
        }
        async function eB(e, t) {
            let n = Math.ceil(t.byteLength / 1048576)
              , i = [];
            for (let s = 0; s < n; s++) {
                let a = t.slice(1048576 * s, (s + 1) * 1048576)
                  , l = new FormData;
                l.append("chunk", new Blob([a])),
                l.append("uniqueId", e),
                l.append("chunkIndex", s),
                l.append("shop", I),
                i.push(fetch(`${Q}process-image-data`, {
                    method: "POST",
                    body: l
                }))
            }
            await Promise.all(i)
        }
        function e0(e) {
            let t = e.match(/^data:(image\/[^;]+);base64,/);
            return t ? t[1] : "image/png"
        }
        function ek(e) {
            return ({
                "image/png": "png",
                "image/jpeg": "jpg",
                "image/gif": "gif",
                "image/webp": "webp",
                "image/svg+xml": "svg",
                "image/tiff": "tiff"
            })[e] || "png"
        }
        async function eR(e) {
            try {
                let t = `${Q}add-custom-product`
                  , n = await fetch(t, {
                    method: "POST",
                    body: e
                });
                if (!n.ok)
                    throw Error(`HTTP error! Status: ${n.status}`);
                let i = await n.json();
                return i
            } catch (s) {
                throw console.error("Error calling add product API:", s),
                s
            }
        }
        async function e1(e, t) {
            var n = new FormData;
            if ("1" == j.isConvertRateRequired) {
                let i = (F / Shopify.currency.rate).toFixed(2);
                n.append("productPrice", i)
            } else
                n.append("productPrice", F.toFixed(2));
            n.append("productTitle", T.title),
            !0 == C ? (n.append("finalWidth", j.sampleOrderWidth),
            n.append("finalHeight", j.sampleOrderHeight)) : "0" == j.isMultiInputs && (n.append("finalWidth", s.value),
            n.append("finalHeight", a.value)),
            n.append("productId", T.id);
            var l = JSON.stringify(L);
            return n.append("variant_dtls", l),
            n.append("prodOptions", JSON.stringify(T.options)),
            n.append("shop", I),
            n.append("uniqueId", e),
            n.append("mainUniqueId", T.id + "_" + eL()),
            n.append("addImageToCart", j.addImageToCart),
            n.append("productImage", S),
            "" == e || "0" == j.addImageToCart && ("-1" == e ? (n.append("imageMIMEType", K),
            n.append("imageExt", ek(K)),
            n.append("imageData", new Blob([t]))) : (n.append("imageMIMEType", K),
            n.append("imageExt", ek(K)))),
            await eR(n)
        }
        function eP() {
            let e = document.getElementById("ngs-preview")
              , t = e.src.split(",")[1];
            return t.replace(/^data:image\/\w+;base64,/, "")
        }
        function ez(e, t) {
            let n = e.replace(/^data:image\/\w+;base64,/, "")
              , i = atob(n)
              , s = Array(i.length);
            for (let a = 0; a < i.length; a++)
                s[a] = i.charCodeAt(a);
            let l = new Uint8Array(s);
            return new Blob([l],{
                type: t
            })
        }
        async function eH(e, t) {
            return tb(),
            await e1(e, t)
        }
        async function eA() {
            var e;
            tb();
            let t = `https://${I}/api/products.json`
              , n = "t_009";
            "sku"in L && (n = "t_" + L.sku);
            let i = [];
            if (E || "0" == j.isImageVisualiser)
                i = [{
                    src: S
                }];
            else {
                let s = eP();
                i = [{
                    position: 1,
                    attachment: s,
                    filename: "ngscustom." + ek(K)
                }]
            }
            console.log('variant_dtls["title"]', L.title),
            console.log("currentProduct.title", T.title),
            console.log("option2", L.option2);
            let a = {
                product: {
                    title: T.title,
                    body_html: "<strong>Description</strong>",
                    vendor: "ngs custom",
                    product_type: "ngs custom",
                    published: !0,
                    images: i,
                    metafields: [{
                        key: "hidden",
                        value: 1,
                        type: "number_integer",
                        namespace: "seo",
                        name: "ngs_customize_meta"
                    }],
                    variants: [{
                        title: L.title,
                        price: F,
                        sku: n,
                        option1: L.option1,
                        option2: L.option2,
                        option3: L.option3,
                        taxable: L.taxable,
                        grams: L.grams,
                        weight: L.weight,
                        weight_unit: L.weight_unit,
                        requires_shipping: L.requires_shipping
                    }]
                }
            }, l;
            return await e2(t, "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", a = (e = a,
            l = 0,
            T.options.forEach(t => {
                if ("Title" === t.name)
                    return;
                void 0 === e.product.options && (e.product.options = []);
                let n = `option${l + 1}`;
                e.product.options.push({
                    name: t.name,
                    position: l,
                    values: [L[n]]
                }),
                l++
            }
            ),
            e))
        }
        async function e2(e, t, n) {
            try {
                let i = await fetch(e, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(n)
                });
                if (!i.ok) {
                    let s = await i.json();
                    throw Error(`HTTP error ${i.status}: ${s.errors}`)
                }
                let a = await i.json();
                return a
            } catch (l) {
                console.error("Error adding product:", l)
            }
        }
        async function e6(e) {
            let n = 1
              , i = ""
              , s = document.querySelectorAll('[name="quantity"]');
            "1" == j.splNotesRequired && (i = document.getElementById("ngs-spl-instructions").value),
            s.length > 0 && (n = s[0].value);
            var a = {
                items: [{
                    quantity: n,
                    id: e.product.variants[0].id,
                    price: e.product.variants[0].price,
                    properties: {
                        [j.sizeText]: t,
                        [j.priceText]: F.toFixed(2)
                    }
                }]
            };
            if (i.trim().length > 0 && (a.items[0].properties[j.splNotesText] = i.trim()),
            "1" == j.isMultiInputs && (a.items[0].properties["Total Moldings Qty"] = document.querySelectorAll(".ngs-size-input").length),
            "warren-reed.myshopify.com" == I) {
                let l = ed();
                l && (console.log("Selection Coordinates:", l),
                a.items[0].properties["Crop X"] = l.x,
                a.items[0].properties["Crop Y"] = l.y,
                a.items[0].properties["Crop Width"] = l.width,
                a.items[0].properties["Crop Height"] = l.height)
            }
            a = function e(t) {
                for (var n = 0; n < J.length; n++) {
                    var i = `[name="properties[${J[n]}]"]`;
                    $(i).length > 0 && (t.items[0].properties[J[n]] = $(i).val())
                }
                return t
            }(a),
            eF(t, a)
        }
        async function e3(e, t) {
            e7(t)
        }
        async function eF(e, t) {
            let n = new FormData;
            if ("1" == j.isImageVisualiser && "1" == j.addImageToCart && "1" == j.isImageCrop) {
                await function e(t="ngs-photo") {
                    if ("0" == j.isImageVisualiser)
                        return;
                    let n = document.getElementById("ngs-preview")
                      , i = n.src
                      , s = i.replace(/^data:image\/(png|jpeg|jpg|webp|tiff|tif);base64,/, "")
                      , a = atob(s)
                      , l = Array(a.length);
                    for (let r = 0; r < a.length; r++)
                        l[r] = a.charCodeAt(r);
                    let o = new Uint8Array(l)
                      , u = new Blob([o],{
                        type: K
                    })
                      , d = new File([u],"uploaded-image.webp",{
                        type: "image/webp"
                    })
                      , c = new DataTransfer;
                    c.items.add(d);
                    let p = document.getElementById(t);
                    p.files = c.files;
                    let g = new Event("change",{
                        bubbles: !0
                    });
                    p.dispatchEvent(g)
                }();
                let i = document.getElementById("ngs-photo");
                i.files.length > 0 && n.append(`properties[${j.cartCropImageText}]`, i.files[0])
            }
            if (Object.entries(t.items[0]).forEach( ([e,i]) => {
                "properties" === e ? Object.entries(t.items[0].properties).forEach( ([e,t]) => {
                    n.append(`properties[${e}]`, t)
                }
                ) : n.append(e, i)
            }
            ),
            "1" == j.isCustomImageFileUpload && "0" == j.uploadImageAsMainImage) {
                let s = document.getElementById(j.customImageFileUploadSelector);
                null != s && s.files.length > 0 && n.append(`properties[${j.customImageFileUploadProperty}]`, s.files[0])
            }
            fetch("/cart/add.js", {
                method: "POST",
                body: n,
                headers: {
                    Accept: "application/json"
                }
            }).then(e => {
                if (!e.ok)
                    throw Error("Network response was not ok");
                return e.json()
            }
            ).then(e => {
                ej()
            }
            ).catch(e => {
                alert(e.message)
            }
            )
        }
        async function e7(e, t=15) {
            if (0 === t) {
                console.log("Reached maximum attempts without finding items.");
                return
            }
            try {
                let n = await eN(e);
                n && n.items && n.items.length > 0 ? ej() : setTimeout( () => e7(e, t - 1), 1e3)
            } catch (i) {
                console.error("Error:", i),
                alert("Error: " + i.message)
            }
        }
        async function eN(e) {
            try {
                let t = await fetch("/cart/add.js", {
                    method: "POST",
                    body: JSON.stringify(e),
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
                if (!t.ok)
                    throw Error("Network response was not ok");
                let n = await t.json();
                return n
            } catch (i) {
                throw i
            }
        }
        function ej() {
            setTimeout( () => {
                window.location.href = q + "/cart"
            }
            , 1e3)
        }
        function eD() {}
        async function eU(e="ngs-photo") {
            if ("0" == j.isImageVisualiser)
                return;
            let t = document.getElementById("ngs-preview")
              , n = t.src;
            await eO(n, e)
        }
        async function eW(e) {
            try {
                let t = window.firebaseStorage
                  , {ref: n, uploadBytes: i, getDownloadURL: s} = window.firebaseStorageUtils
                  , a = function e(t="webp") {
                    let n = Date.now()
                      , i = Math.random().toString(36).substring(2, 10);
                    return `img_${n}_${i}.${t}`
                }()
                  , l = n(t, "shopify-images/" + a)
                  , r = await i(l, e)
                  , o = await s(r.ref);
                return console.log("✅ Image uploaded to:", o),
                o
            } catch (u) {
                throw console.error("❌ Firebase upload failed:", u),
                u
            }
        }
        async function eO(e, t) {
            let n = e.replace(/^data:image\/(png|jpeg|jpg|webp|tiff|tif);base64,/, "")
              , i = atob(n)
              , s = Array(i.length);
            for (let a = 0; a < i.length; a++)
                s[a] = i.charCodeAt(a);
            let l = new Uint8Array(s)
              , r = new Blob([l],{
                type: K
            });
            if ("1" == j.isImageExternal) {
                let o = await eW(r);
                document.getElementById(t).value = o;
                return
            }
            let u = new File([r],"uploaded-image.webp",{
                type: "image/webp"
            })
              , d = new DataTransfer;
            d.items.add(u);
            let c = document.getElementById(t);
            c.files = d.files;
            let p = new Event("change",{
                bubbles: !0
            });
            c.dispatchEvent(p)
        }
        async function e5(e, t="ngs-photo") {
            e.toBlob(e => {
                let n = new File([e],"wallpaper-preview.png",{
                    type: "image/png"
                })
                  , i = new DataTransfer;
                i.items.add(n);
                let s = document.getElementById(t);
                s.files = i.files;
                let a = new Event("change",{
                    bubbles: !0
                });
                s.dispatchEvent(a),
                console.log("File assigned to input:", n.name)
            }
            , "image/png")
        }
        async function e4() {
            let e = c
              , t = p
              , n = document.getElementById("previewCanvas")
              , i = n.getContext("2d")
              , s = e.offsetWidth
              , a = e.offsetHeight
              , l = S
              , r = new Image;
            r.crossOrigin = "anonymous",
            r.src = l,
            await new Promise( (e, t) => {
                r.onload = e,
                r.onerror = () => {
                    console.error("Image failed to load due to CORS."),
                    alert("Image load failed. Try using a proxy or ensure CORS headers are present."),
                    t()
                }
            }
            );
            let o = r.naturalWidth
              , u = r.naturalHeight
              , d = a
              , g = o / u * d
              , m = parseFloat(getComputedStyle(t).backgroundPositionX) || 0;
            n.width = s,
            n.height = a,
            i.clearRect(0, 0, n.width, n.height),
            i.save(),
            i.translate(m, 0);
            let h = getComputedStyle(t).filter;
            h && "none" !== h && (i.filter = h);
            let f = document.createElement("canvas");
            f.width = g,
            f.height = d;
            let y = f.getContext("2d");
            y.filter = h || "none",
            y.drawImage(r, 0, 0, g, d);
            let v = i.createPattern(f, "repeat-x");
            i.filter = "none",
            i.fillStyle = v,
            i.fillRect(-m, 0, n.width + Math.abs(m), n.height),
            i.restore();
            let w = document.querySelector(".ngs-grid-panel-lines")
              , _ = "none" !== getComputedStyle(w).display;
            if (_) {
                let b = parseFloat(getComputedStyle(w).backgroundSize) || 28.5;
                i.beginPath(),
                i.strokeStyle = "#9999ff",
                i.lineWidth = 1;
                for (let x = 0; x < n.width; x += b)
                    i.moveTo(x, 0),
                    i.lineTo(x, n.height);
                i.stroke()
            }
            eO(n.toDataURL("image/png"), "ngs-photo")
        }
        function eV() {
            n = document.getElementById("ngs-image"),
            i = document.getElementById("ngs-selection"),
            s = document.getElementById("ngs-width-input"),
            a = document.getElementById("ngs-height-input"),
            l = document.getElementById("ngs-preview-btn"),
            r = document.getElementById("ngs-preview"),
            o = document.getElementById("ngs-mirror-toggle"),
            u = document.querySelector(".ngs-container"),
            d = document.getElementById("ngs-measure_type")
        }
        function eX(e) {
            if (e = e.trim()) {
                let t = document.querySelector(e);
                t && (t.style.display = "none")
            }
        }
        async function eY(e) {
            if ("1" == j.isCartTransformer) {
                await eT(),
                null != document.querySelector('[name="add"]') ? (document.querySelector('[name="add"]').click(),
                F = 0,
                C = !1,
                setTimeout( () => {
                    eq(e, !0)
                }
                , 1e3)) : N.submit();
                return
            }
            var t = await eH("", null);
            if ("1" == t.statusCode) {
                await e6(t);
                return
            }
            alert("Error")
        }
        function eQ(e, t) {
            let n = e.parentNode;
            "b" === j.targetPosition ? n.insertBefore(t, e) : "a" === j.targetPosition ? n.insertBefore(t, e.nextSibling) : "f" === j.targetPosition ? e.insertBefore(t, e.firstChild) : "l" === j.targetPosition && e.appendChild(t),
            eX(j.hideCartButton),
            eX(j.priceElement),
            function e() {
                let t = j.hideBuyButtons.trim();
                if (t) {
                    let n = t.split(",").map(e => e.trim());
                    n.forEach(e => {
                        eX(e)
                    }
                    )
                }
                "1" == j.sampleOrderButtonRequired && function e() {
                    let t = document.querySelector(".ngs-wrapper")
                      , n = t.parentNode
                      , i = document.createElement("button");
                    i.id = "ngs-sample-order-btn",
                    i.className = "ngs-sample-order-btn";
                    let s = document.createElement("span");
                    s.className = "ngs-button-text",
                    s.textContent = j.sampleOrderButtonText,
                    i.appendChild(s),
                    n.insertBefore(i, t.nextSibling),
                    i.addEventListener("click", async e => (e.preventDefault(),
                    eI(i, !0),
                    C = !0,
                    F = j.sampleOrderPrice * Shopify.currency.rate,
                    await eY(i),
                    !1));
                    let a = document.createElement("p");
                    a.textContent = j.sampleOrderNotes,
                    a.className = "ngs-sample-note",
                    n.insertBefore(a, i.nextSibling)
                }()
            }()
        }
        async function eG() {
            let e = null
              , t = j.targetElementSelector;
            if ("" == t || "old" == t) {
                let n = document.querySelector('form[action="/cart/add"]');
                n && (N = n,
                e = n.querySelector('button[name="add"]')),
                e || (e = document.querySelector('button[name="add"]'))
            } else
                e = document.querySelector(t);
            return (N = e ? e.closest("form") : null,
            null === e) ? (await new Promise(e => setTimeout(e, 300)),
            eG()) : e
        }
        function eZ(e) {
            productId = T.id,
            e.ImageIndex > -1 && (S = e.ImageIndex < images.length ? T.images[e.ImageIndex] : T.images[0]),
            T && (S = T.featured_image && "" != T.featured_image ? T.featured_image : T.images[0])
        }
        function eJ(e, t) {
            let n = e.getAttribute("action");
            return n && n.includes(t)
        }
        async function eK(e, t) {
            if ("0" == j.isCustomSizeToggle)
                return;
            let n = document.querySelectorAll(".buy-buttons, .product-form__item--payment-button, .shopify-payment-button");
            try {
                "pageLoad" == t || "variantChange" == t && "0" == j.isTwoCustomSizeToggle ? (await tv(),
                (L.option1?.toLowerCase().includes("custom size") || L.option2?.toLowerCase().includes("custom size") || L.option3?.toLowerCase().includes("custom size") || e) && (ee = !0,
                e = !0)) : e = ee
            } catch (i) {}
            e ? (n.forEach(e => {
                e.style.display = "none"
            }
            ),
            document.querySelector(".ngs-top-container").style.display = "") : (n.forEach(e => {
                e.style.display = ""
            }
            ),
            document.querySelector(".ngs-top-container").style.display = "none"),
            function e(t) {
                if ("0" == j.isTwoCustomSizeToggle)
                    return;
                let n = document.querySelector("variant-picker");
                if (!n)
                    return;
                let i = n.querySelectorAll("fieldset.variant-picker__option");
                if (i.length < 3)
                    return;
                let s = i[2];
                s.querySelectorAll("label"),
                t ? s.style.display = "none" : s.style.display = ""
            }(e),
            function e() {
                try {
                    if ("0" == j.isTwoCustomSizeToggle)
                        return;
                    let t = document.querySelector("variant-picker")
                      , n = t.querySelector("fieldset.variant-picker__option");
                    if (!n)
                        return;
                    let i = n.querySelectorAll('input[type="radio"]');
                    i.forEach(e => {
                        e.dataset.bound || (e.dataset.bound = "true",
                        e.addEventListener("change", function(n) {
                            let i = document.querySelector(`label[for="${e.id}"]`)
                              , s = i?.textContent?.trim();
                            if (ee = !1,
                            s && "custom size" === s.toLowerCase()) {
                                ee = !0,
                                eK(!0, "beforeClick");
                                let a = t.querySelectorAll("fieldset.variant-picker__option");
                                if (a.length >= 3) {
                                    let l = a[2]
                                      , r = Array.from(l.querySelectorAll("label")).find(e => "custom size" === e.textContent?.trim().toLowerCase());
                                    r && r.click()
                                }
                            } else
                                eK(!1, "beforeClick")
                        }))
                    }
                    )
                } catch (s) {
                    console.log("bindRadioEventsCustomSize", s)
                }
            }()
        }
        async function te() {
            !function e() {
                let t = document.querySelectorAll("form");
                t.forEach(function(e) {
                    (eJ(e, "/cart/add") || eJ(e, "/cart/add.js")) && e.addEventListener("change", function(e) {
                        setTimeout( () => {
                            if (ts(e),
                            "576e53-e4.myshopify.com" == I) {
                                let t = document.querySelector(".shopify-product-form")
                                  , n = document.createElement("div");
                                n.innerHTML = eh(),
                                t.appendChild(n)
                            }
                            let i = document.querySelector(".ngs-top-container");
                            if (null == i)
                                return;
                            let s = !i.contains(e.target);
                            s && eK(!1, "variantChange")
                        }
                        , 100)
                    })
                })
            }(),
            E = e9();
            let e = await eG();
            E || "1" == j.isInlineUpload ? e ? function e(t) {
                let n = document.createElement("div");
                n.innerHTML = function e() {
                    let t = "";
                    if ("1" == j.isInlineUpload)
                        t = `<div class="ngs-wrapper">
                <div class="ngs-controls">
                    <div>
                    ${eb()}
                    </div>
                    <div style="margin-top:10px;">
                    <button id="ngs-add-to-cart" style="width:100%">  <span class="ngs-button-text">${j.addToCartButtonText}</span></button>
                    </div>
                </div>
                </div>`;
                    else if ("0" == j.isMultiInputs)
                        t = `<div class="ngs-wrapper">
                <div class="ngs-controls">
                    ${eb()}
                    ${e_()}
                    ${eh()}
                    <button id="ngs-add-to-cart">  <span class="ngs-button-text">${j.addToCartButtonText}</span></button>
                </div>
                </div>`;
                    else {
                        let n = "";
                        "1" == j.instructionRequired && (n = `<div class="ngs-input-other-item ngs-div-instructions">
                          <label id="ngs-instructions">${j.instructionsContent}</label>
                      </div>`);
                        let i = "";
                        "1" == j.splNotesRequired && (i = ` <div class="ngs-input-other-item ngs-spl-notes">
                                       
                                        <textarea id="ngs-spl-instructions" placeholder="Geef hier je speciale zaagwensen door, zoals afwijkende hoeken" ></textarea>
                                    </div>`),
                        t = `<div class="ngs-wrapper">
                <div class="ngs-controls">
                  
                   
                    <table id="ngs-sizeTable">
                        <tbody>
                            ${function e() {
                            let t = "";
                            for (let n = 0; n < 8; n++)
                                t += `<tr>
                            <td class="ngs-size-label">Sierlijst ${n + 1} (cm)</td>
                            <td class="ngs-size-value"><input class="ngs-size-input ngs-main-rows" type="number" min="20" max="250" value="" placeholder="Maat invoeren"></td>
                            <td class="ngs-size-remove"></td>
                        </tr>`;
                            return t
                        }()}
                          
                        </tbody>
                    </table>
                    ${n}
                    <button class="ngs-add-row" >Voeg sierlijst toe</button>
                    <button id="ngs-add-to-cart">  <span class="ngs-button-text">${j.addToCartButtonText}</span></button>
                    <div class="ngs-multi-total"></div>
                    <div class="ngs-multi-total-tax">Inclusief btw en verzending</div>
                                      
                    ${i}
                   
                </div>
            </div>`
                    }
                    return "576e53-e4.myshopify.com" == I && ex(document.querySelector(".shopify-product-form")),
                    "fableroom-website.myshopify.com" == I && ex(document.querySelector(".js-product-form-main")),
                    t
                }(),
                n.classList.add("ngs-top-container"),
                eQ(t, n),
                eC(),
                eV(),
                tc(),
                ta(),
                eK(!1, "pageLoad")
            }(e) : console.error('Element with class "addtocart" not found.') : function e(t) {
                let r = document.createElement("button");
                if (r.textContent = j.popupButtonText,
                r.id = "ngs-show-popup-btn",
                eQ(t, r),
                "fableroom-website.myshopify.com" == I)
                    ex(document.querySelector(".js-product-form-main"));
                else {
                    let u = document.createElement("div");
                    u.innerHTML = eh(),
                    t.parentNode.insertBefore(u, t)
                }
                let d = document.createElement("div");
                d.style.display = "none",
                document.body.appendChild(d),
                d.className = "ngs-popup-overlay",
                r.addEventListener("click", function(e) {
                    var t;
                    e.preventDefault();
                    let r, u, c, g;
                    (t = d).innerHTML = t.innerHTML = `
            <div class="ngs-popup-content">
                <button id="ngs-popup-close-btn" class="ngs-popup-close-btn">&times;</button>
                <h2 class="ngs-popup-header">${j.popupMainHeaderText}</h2>
                <div class="ngs-popup-description">${j.popupMainHeaderDesc}</div>
                ${r = "",
                    "1" == j.isImageVisualiser && (r = '<div id="ngs-selection" class="ngs-selection-box"></div>'),
                    u = "display:none",
                    "1" == j.previewRequired && (u = ""),
                    c = "",
                    "1" == j.mirrorRequired && (c = `<div class="ngs-mirror-toggle-container" >
                    <label class="ngs-mirror-toggle-switch">
                        <input type="checkbox" id="ngs-mirror-toggle">
                        <span class="ngs-slider"></span>
                    </label>
                    <span>${j.mirrorText}</span>
                </div>`),
                    `<div class="ngs-wrapper ngs-cal-modal">
                           ${g = "1" == j.isImageCrop ? ` <div class="ngs-container">
                                    <img id="ngs-image" src="${S}" alt="Image">
                                    ${r}
                                </div>` : `       <div  class="ngs-top-image-repeat">
                                                    <div id="divRepeatImageContainer" class="ngs-actual-image-repeat" style="
                                                    background-image: url('${S}'); "></div>
                                                    <div class="ngs-grid-panel-lines" style="display:none" ></div>
                                                </div>
                                                
                                                <canvas id="previewCanvas" style="display:none"></canvas>
`}
                            <div class="ngs-controls">
                                ${eb()}
                                ${e_()}
                                ${c}
                                ${function e() {
                        if ("0" == j.filtersRequired)
                            return "";
                        let t = j.filterValues
                          , n = '<div class="ngs-main-filter">';
                        return t.forEach(e => {
                            n += `
                <input type="radio" id="ngs-${e.id}" class="ngs-filter-option" name="ngs-filter" value="${e.value}">
                <label for="ngs-${e.id}">${e.label}</label>
            `
                        }
                        ),
                        n += "</div>"
                    }()}
                                ${"0" == j.PanelsRequired ? "" : `<div class="ngs-panel-toggle-container">
          <label class="ngs-panel-toggle-switch">
              <input type="checkbox" id="ngs-panel-toggle">
              <span class="ngs-panel-slider"></span>
          </label>
          <span>Show Panels</span>
      </div>
      <button id="downloadRepeatImageBtn">Download Image</button>
      `}
                                <button id="ngs-add-to-cart">  <span class="ngs-button-text">${j.addToCartButtonText}</span></button>
                                <button style="${u}" id="ngs-preview-btn">Preview</button>
                            </div>
                        </div>
      
                    <div class="ngs-preview-container" style="${u}">
                        <img id="ngs-preview"  class="preview-img" alt="Preview Image">
                    </div>`}
            </div>`,
                    document.body.classList.add("ngs-no-scroll"),
                    t.style.display = "flex",
                    eV(),
                    em(),
                    tc(),
                    tm(),
                    "0" != j.isImageVisualiser && (l.addEventListener("click", ec),
                    "1" == j.mirrorRequired && o.addEventListener("click", eg),
                    null != i && (i.addEventListener("mousedown", e => {
                        tg(e)
                    }
                    ),
                    i.addEventListener("touchstart", e => {
                        tg(e)
                    }
                    ),
                    "1" == j.resizeImageRequired && Object.keys(G).forEach(e => {
                        let t = document.createElement("div");
                        t.className = `ngs-resize-handle ${e}`,
                        i.appendChild(t),
                        t.addEventListener("mousedown", eo),
                        t.addEventListener("touchstart", eo)
                    }
                    )),
                    "1" == j.isPopup && "0" == j.isImageCrop && (p.addEventListener("mousedown", e => ei(e.clientX)),
                    document.addEventListener("mousemove", e => es(e.clientX)),
                    document.addEventListener("mouseup", ea),
                    p.addEventListener("touchstart", e => ei(e.touches[0].clientX)),
                    document.addEventListener("touchmove", e => {
                        es(e.touches[0].clientX)
                    }
                    , {
                        passive: !1
                    }),
                    document.addEventListener("touchend", ea),
                    "0" != j.PanelsRequired && document.getElementById("downloadRepeatImageBtn").addEventListener("click", async function(e) {
                        e.preventDefault(),
                        e.stopImmediatePropagation(),
                        domtoimage.toPng(document.querySelector(".ngs-popup-overlay")).then(function(e) {
                            let t = document.createElement("a");
                            t.download = "form-screenshot.png",
                            t.href = e,
                            t.click()
                        })
                    })),
                    "0" != j.filtersRequired && document.querySelectorAll(".ngs-filter-option").forEach(e => {
                        e.addEventListener("change", function() {
                            document.querySelectorAll(".ngs-main-filter label").forEach(e => e.classList.remove("ngs-filter-selected")),
                            document.querySelectorAll(".ngs-main-filter label").forEach(e => {
                                e.classList.remove("ngs-filter-selected")
                            }
                            );
                            let t = document.querySelector(`label[for="${e.id}"]`);
                            t && t.classList.add("ngs-filter-selected");
                            let i = document.querySelector(".ngs-filter-option:checked")?.value || "none";
                            n && (n.style.filter = i);
                            let s = document.getElementById("divRepeatImageContainer");
                            s && (s.style.filter = i)
                        })
                    }
                    ),
                    document.addEventListener("change", function(e) {
                        e.target && "ngs-panel-toggle" === e.target.id && ("none" === m.style.display || "" === m.style.display ? m.style.display = "block" : m.style.display = "none")
                    })),
                    eC(),
                    j?.isSetQuantity == "1" && (document.querySelector(".ngs-final-price").style.display = "none",
                    document.querySelector(".ngs-actual-price").style.display = "none",
                    document.querySelector("#ngs-add-to-cart").style.display = "none",
                    document.querySelector(".ngs-calculate-tiles-button").addEventListener("click", async function(e) {
                        e.preventDefault();
                        let t = D.tileSize
                          , n = parseFloat(s.value)
                          , i = parseFloat(a.value)
                          , l = Math.ceil(n * i / t);
                        document.querySelector(".ngs-exact-quantity-value").textContent = l,
                        document.querySelector(".ngs-with-waste-value").textContent = Math.ceil(1.1 * l),
                        document.querySelector(".ngs-tiles-container").style.display = "block",
                        document.querySelector("#ngs-add-to-cart").style.display = "block"
                    })),
                    ta(),
                    ec(),
                    t.addEventListener("click", function(e) {
                        var n;
                        "ngs-popup-close-btn" === e.target.id && (n = t,
                        document.body.classList.remove("ngs-no-scroll"),
                        n.style.display = "none")
                    })
                })
            }(e),
            function e() {
                if (j.scripts.trim().length > 0) {
                    let t = document.createElement("script");
                    t.textContent = j.scripts,
                    document.body.appendChild(t)
                }
            }(),
            function e() {
                if (j.styles.trim().length > 0) {
                    let t = document.createElement("style");
                    t.textContent = j.styles,
                    document.head.appendChild(t)
                }
            }()
        }
        function tt(e, t) {
            let n;
            if ("feet" === (t = t.toLowerCase()))
                n = .3048 * e / 2;
            else if ("inch" === t)
                n = .0254 * e / 2;
            else if ("cm" === t)
                n = .01 * e / 2;
            else if ("meter" === t)
                n = e / 2;
            else if ("mm" === t)
                n = .001 * e / 2;
            else
                throw Error("Invalid measureType");
            let i = Math.PI * Math.pow(n, 2);
            return i
        }
        function tn(e) {
            return parseFloat((e / 10.7639).toFixed(2))
        }
        function ti() {
            k = B;
            let e = "";
            "sq ft" == j.priceUnitType ? e = "ft<sup>2</sup>" : "sq meter" == j.priceUnitType && (e = "m<sup>2</sup>"),
            null != d && "sq meter" == j.priceUnitType && ("inch" == d.value.toLowerCase() ? (k = tn(B),
            e = "ft<sup>2</sup>") : "feet" == d.value.toLowerCase() && (k = tn(B),
            e = "ft<sup>2</sup>")),
            null != document.getElementById("ngs-measure-price") && (document.getElementById("ngs-measure-price").innerHTML = `${j.priceSymbol}${k} / ${e}`)
        }
        async function ts() {
            L = await tv(),
            ti(),
            E && ta()
        }
        async function ta(e=!0) {
            try {
                if ("1" == j.isMultiInputs) {
                    await eS();
                    return
                }
                let t = parseFloat(document.getElementById("ngs-width-input").value);
                if (("D" == j.shapeType || "S" == j.shapeType) && (document.getElementById("ngs-height-input").value = t,
                "1" == j.isInchesRequired)) {
                    let n = parseFloat(document.getElementById("ngs-width-sub-inches").value);
                    document.getElementById("ngs-height-sub-inches").value = n
                }
                let i = parseFloat(document.getElementById("ngs-height-input").value), s;
                "sq meter" === j.priceUnitType ? s = function e(t, n, i) {
                    if ("feet" === (i = i.toLowerCase()))
                        return .3048 * t * (.3048 * n);
                    if ("inch" === i)
                        return .0254 * t * (.0254 * n);
                    if ("cm" === i)
                        return .01 * t * (.01 * n);
                    if ("meter" === i)
                        return t * n;
                    if ("mm" === i)
                        return .001 * t * (.001 * n);
                    else
                        throw Error("Invalid measureType")
                }(t, i, d.value) : "sq ft" === j.priceUnitType && (s = function e(t, n, i) {
                    if ("meter" === (i = i.toLowerCase()))
                        return 3.28084 * t * (3.28084 * n);
                    if ("cm" === i)
                        return .0328084 * t * (.0328084 * n);
                    if ("inch" === i)
                        return .0833333 * t * (.0833333 * n);
                    if ("feet" === i) {
                        if ("1" == j.isInchesRequired) {
                            let s = parseFloat(document.querySelector("#ngs-width-sub-inches").value)
                              , a = parseFloat(document.querySelector("#ngs-height-sub-inches").value);
                            t += s / 12,
                            n += a / 12
                        }
                        return t * n
                    }
                    if ("mm" === i)
                        return .00328084 * t * (.00328084 * n);
                    else
                        throw Error("Invalid measureType")
                }(t, i, d.value)),
                "72b1c2-3e.myshopify.com" == I ? (s *= 1.1,
                F = Math.round(s * B)) : F = s * B,
                "fc28f4-d9.myshopify.com" == I && F < parseFloat(D.minOrder) && (F = parseFloat(D.minOrder));
                let a = F.toFixed(2);
                if (document.getElementById("ngs-final-price").innerHTML = tl(a),
                "1" == j.isTotalMeasurementsRequired && (document.getElementById("ngs-total-measurement-value").innerHTML = s.toFixed(2)),
                "" != j.changeMainPriceAlso) {
                    let l = document.querySelector(j.changeMainPriceAlso);
                    l && parseFloat(F.toFixed(2)) > 0 && (l.textContent = j.priceSymbol + F.toFixed(2) + " GBP")
                }
                !E && e && er()
            } catch (r) {}
        }
        function tl(e) {
            let t = "";
            return j.priceSymbolPlace ? isNaN(e) ? `0.00 ${j.priceSymbol}` : `${e} ${j.priceSymbol}` : isNaN(e) ? `${j.priceSymbol} 0.00` : `${j.priceSymbol} ${e}`
        }
        function tr() {}
        function to() {
            let e = {
                widthText: "",
                heightText: ""
            }
              , t = "inch" === d.value ? "Inch" : d.value;
            ev(e, d.value),
            document.querySelectorAll(".ngs-side-measure").forEach(e => {
                e.textContent = t
            }
            ),
            e.widthText = e.widthText.replace(/\(([^)]+)\)/, `(${t})`),
            e.heightText = e.heightText.replace(/\(([^)]+)\)/, `(${t})`);
            let n = "feet" === d.value;
            "1" == j.isInchesRequired && (document.querySelectorAll(".ng-sub-inch-select").forEach(e => {
                e.style.display = n ? "" : "none"
            }
            ),
            document.querySelectorAll(".ngs-dimension-title-sub-inch").forEach(e => {}
            ));
            let i = parseFloat(document.querySelector("#ngs-width-input").value)
              , s = parseFloat(document.querySelector("#ngs-height-input").value);
            isNaN(i) ? document.querySelector("#ngs-width-input").value = "" : document.querySelector("#ngs-width-input").value = tu(i, Y, d.value),
            isNaN(s) ? document.querySelector("#ngs-height-input").value = "" : document.querySelector("#ngs-height-input").value = tu(s, Y, d.value),
            "1" == j.isInchesRequired && (document.querySelector("#ngs-width-input").value = "",
            document.querySelector("#ngs-height-input").value = "",
            document.querySelector("#ngs-width-sub-inches").value = "0",
            document.querySelector("#ngs-height-sub-inches").value = "0"),
            Y = d.value;
            let a = document.querySelector(".ngs-trim-value");
            a && (a.textContent = d?.value === "inch" ? '2"' : "5cm"),
            "1" == j.placeHoldersRequired && (document.querySelector("#ngs-width-input").placeholder = t,
            document.querySelector("#ngs-height-input").placeholder = t),
            document.querySelector(".ngs-width-title").innerHTML = e.widthText,
            document.querySelector(".ngs-height-title").innerHTML = e.heightText,
            "1" == j.isShapesRequired && tp(),
            W = "1" === D.isMinSizeEnable ? D.minWidth : 0,
            O = "1" === D.isMaxSizeEnable ? D.maxWidth : 1 / 0,
            widthValue = Math.max(W = tu(W, j.defaultMeasurementType, d.value), Math.min(O = tu(O, j.defaultMeasurementType, d.value), 1)),
            V = "1" === D.isMinSizeEnable ? D.minHeight : 0,
            X = "1" === D.isMaxSizeEnable ? D.maxHeight : 1 / 0,
            V = tu(V, j.defaultMeasurementType, d.value);
            let l = 1;
            l = Math.max(V, Math.min(X = tu(X, j.defaultMeasurementType, d.value), l));
            let r = ""
              , o = "";
            "1" == D.isMinSizeEnable && (D.minWidth > 0 && (r = `Min:${W}`),
            D.minHeight > 0 && (o = `Min:${V}`)),
            "1" == D.isMaxSizeEnable && (D.maxWidth > 0 && (r = `${r} Max:${O}`),
            D.maxHeight > 0 && (o = `${o} Max:${X}`));
            document.querySelector(".ngs-width-min-max").textContent = `${r} ${d.value.toLowerCase()}`;
            document.querySelector(".ngs-height-min-max").textContent = `${o} ${d.value.toLowerCase()}`,
            ti(),
            ta()
        }
        function tu(e, t, n) {
            let i = {
                MM: {
                    CM: .1,
                    METER: .001,
                    INCH: .0393701,
                    FEET: .00328084
                },
                CM: {
                    MM: 10,
                    METER: .01,
                    INCH: .393701,
                    FEET: .0328084
                },
                METER: {
                    MM: 1e3,
                    CM: 100,
                    INCH: 39.3701,
                    FEET: 3.28084
                },
                INCH: {
                    MM: 25.4,
                    CM: 2.54,
                    METER: .0254,
                    FEET: .0833333
                },
                FEET: {
                    MM: 304.8,
                    CM: 30.48,
                    METER: .3048,
                    INCH: 12
                }
            };
            return (t = t.toUpperCase()) === (n = n.toUpperCase()) ? e : t in i && n in i[t] ? parseFloat((e * i[t][n]).toFixed(2)) : (console.warn(`Conversion from ${t} to ${n} is not supported.`),
            parseFloat(e.toFixed(2)))
        }
        function td(e, t, n) {
            n.preventDefault(),
            s.value = e,
            a.value = t,
            ta()
        }
        function tc() {
            if (null != document.querySelector(".ngs-measure-unit-toggle") && document.querySelector(".ngs-measure-unit-toggle").addEventListener("click", function() {
                let e = this.getAttribute("data-current-value");
                Y = e;
                let t = j.measurementTypes.split(",")
                  , n = (t.indexOf(e) + 1) % t.length
                  , i = t[n];
                this.setAttribute("data-current-value", i),
                this.setAttribute("data-index", n),
                d.value = i;
                let s = new Event("change",{
                    bubbles: !0
                });
                d.dispatchEvent(s)
            }),
            "1" == j.isMultiInputs) {
                !function e() {
                    let t = document.querySelector('input[name="id"]');
                    t && t.removeAttribute("disabled"),
                    document.querySelector(".ngs-add-row").addEventListener("click", async function(e) {
                        e.preventDefault();
                        let t, n, i, s, a;
                        i = (n = (t = document.getElementById("ngs-sizeTable").getElementsByTagName("tbody")[0]).insertRow()).insertCell(0),
                        s = n.insertCell(1),
                        a = n.insertCell(2),
                        i.innerHTML = `Sierlijst ${t.rows.length} (cm)`,
                        s.innerHTML = '<input class="ngs-size-input ngs-new-add-rows" type="number" min="20" max="250" value="" placeholder="Maat invoeren">',
                        a.innerHTML = '<button class="ngs-remove-btn" >&#10006;</button>',
                        i.className = "ngs-size-label",
                        s.className = "ngs-size-value",
                        a.className = "ngs-size-remove",
                        eS()
                    }),
                    document.getElementById("ngs-sizeTable").addEventListener("click", async function(e) {
                        e.target.classList.contains("ngs-remove-btn") && (e.preventDefault(),
                        function e(t) {
                            if (document.getElementById("ngs-sizeTable").getElementsByTagName("tbody")[0].rows.length > 8) {
                                let n = t.parentNode.parentNode;
                                n.parentNode.removeChild(n),
                                function e() {
                                    let t = document.getElementsByClassName("ngs-size-label");
                                    for (let n = 0; n < t.length; n++)
                                        t[n].innerHTML = `Sierlijst ${n + 1} (cm)`
                                }()
                            }
                        }(e.target),
                        eS())
                    }),
                    document.addEventListener("input", function(e) {
                        if (e.target.classList.contains("ngs-size-input")) {
                            let t = e.target.value;
                            ((t = t.replace(/[^0-9.]/g, "")).match(/\./g) || []).length > 1 && (t = t.substring(0, t.length - 1)),
                            e.target.value = t,
                            eS()
                        }
                    }),
                    document.addEventListener("blur", function(e) {
                        if (e.target.classList.contains("ngs-size-input")) {
                            let t = parseFloat(e.target.value);
                            isNaN(t) ? e.target.value = "" : t < 20 ? e.target.value = 20 : t > 250 && (e.target.value = 250),
                            eS()
                        }
                    }, !0),
                    eS()
                }();
                return
            }
            if ("1" == j.isInlineUpload) {
                tm();
                return
            }
            s.addEventListener("keydown", e => {
                "Enter" === e.key && (e.preventDefault(),
                s.blur())
            }
            ),
            a.addEventListener("keydown", e => {
                "Enter" === e.key && (e.preventDefault(),
                a.blur())
            }
            ),
            s.addEventListener("change", () => e$("ngs-width-input", W, O)),
            a.addEventListener("change", () => e$("ngs-height-input", V, X)),
            d.addEventListener("change", to);
            let t = document.getElementsByClassName("ngs-preset-button");
            Array.from(t).forEach( (t, n) => {
                t.addEventListener("click", i => {
                    if (e) {
                        let s = parseInt(t.textContent);
                        td(s, s, i)
                    } else {
                        let {width: a, height: l} = U[n];
                        td(a, l, i)
                    }
                }
                )
            }
            ),
            "1" == j.keyPressEventRequired && (s.addEventListener("input", () => {
                e$("ngs-width-input", 0, 0)
            }
            ),
            a.addEventListener("input", () => {
                e$("ngs-height-input", 0, 0)
            }
            )),
            "1" == j.isShapesRequired && document.getElementById("ngs-shape-type").addEventListener("change", function(e) {
                "round" == this.value ? (j.shapeType = "D",
                document.querySelector(".ngs-right-side").style.display = "none") : "square" == this.value ? (j.shapeType = "S",
                document.querySelector(".ngs-right-side").style.display = "none") : (j.shapeType = "R",
                document.querySelector(".ngs-right-side").style.display = ""),
                document.querySelector("#ngs-width-input").value = "",
                document.querySelector("#ngs-height-input").value = "",
                "1" == j.isInchesRequired && (document.querySelector("#ngs-width-sub-inches").value = "0",
                document.querySelector("#ngs-height-sub-inches").value = "0"),
                tp(),
                ta(!1)
            }),
            "1" == j.isInchesRequired && (document.querySelectorAll(".ng-sub-inch-select").forEach(function(e) {
                e.addEventListener("change", function(e) {
                    ta(!1)
                })
            }),
            document.getElementById("ngs-width-input").addEventListener("input", function(e) {
                this.value = this.value.replace(/\D/g, "")
            }),
            document.getElementById("ngs-height-input").addEventListener("input", function(e) {
                this.value = this.value.replace(/\D/g, "")
            }))
        }
        function tp() {
            let e = document.querySelector(".ngs-width-title")
              , t = e.innerText
              , n = t.match(/\s*\(.*\)/)
              , i = n ? n[0] : "";
            "D" == j.shapeType ? e.innerText = "Diameter" + i : "S" == j.shapeType ? e.innerText = "Side" + i : e.innerText = "Width" + i
        }
        function tg(e) {
            s && document.activeElement === s && s.blur(),
            a && document.activeElement === a && a.blur(),
            function e(t) {
                t.preventDefault();
                let s = "touchstart" === t.type
                  , a = s ? t.touches[0].clientX : t.clientX
                  , l = s ? t.touches[0].clientY : t.clientY;
                function r(e) {
                    e.preventDefault(),
                    b && requestAnimationFrame( () => {
                        let t = n.parentElement.getBoundingClientRect()
                          , s = "touchmove" === e.type ? e.touches[0].clientX : e.clientX
                          , a = "touchmove" === e.type ? e.touches[0].clientY : e.clientY
                          , l = y + (s - h)
                          , r = v + (a - f)
                          , o = i.getBoundingClientRect();
                        l = Math.min(Math.max(l, 0), t.width - o.width),
                        r = Math.min(Math.max(r, 0), t.height - o.height),
                        i.style.left = `${l}px`,
                        i.style.top = `${r}px`
                    }
                    )
                }
                function o(e) {
                    e.preventDefault(),
                    b = !1,
                    document.removeEventListener("mousemove", r),
                    document.removeEventListener("mouseup", o),
                    document.removeEventListener("touchmove", r),
                    document.removeEventListener("touchend", o)
                }
                t.target === i && (h = a,
                f = l,
                y = parseInt(i.style.left, 10),
                v = parseInt(i.style.top, 10),
                b = !0,
                document.addEventListener("mousemove", r),
                document.addEventListener("mouseup", o),
                document.addEventListener("touchmove", r),
                document.addEventListener("touchend", o))
            }(e)
        }
        function tm() {
            null != document.getElementById("ngs-upload-fake") && document.getElementById("ngs-upload-fake").addEventListener("click", function() {
                null != document.getElementById("ngs-upload") && document.getElementById("ngs-upload").click()
            }),
            null != document.getElementById("ngs-upload") && document.getElementById("ngs-upload").addEventListener("change", function(e) {
                let t = e.target.files[0];
                if (t) {
                    let n = new FileReader;
                    n.onload = function(e) {
                        (function e(t) {
                            if (t.startsWith("data:image/tiff") || t.startsWith("data:image/x-tiff")) {
                                let n = t.split(",")[1]
                                  , i = atob(n)
                                  , s = i.length
                                  , a = new Uint8Array(s);
                                for (let l = 0; l < s; l++)
                                    a[l] = i.charCodeAt(l);
                                try {
                                    let r = new Tiff({
                                        buffer: a
                                    })
                                      , o = r.toCanvas();
                                    o ? th(o.toDataURL()) : console.error("Failed to process TIFF.")
                                } catch (u) {
                                    console.error("Error processing TIFF:", u)
                                }
                            } else
                                th(t)
                        }
                        )(e.target.result)
                    }
                    ,
                    n.readAsDataURL(t)
                }
            })
        }
        function th(e) {
            n ? n.src = e : console.error("Image element not found!"),
            n.onload = function() {
                console.log("New image loaded:", n.src),
                em()
            }
            ,
            n.onerror = function() {
                console.error("Failed to load image:", src)
            }
            ,
            n.complete && (console.log("New image complete event:", src),
            em())
        }
        function tf(e) {
            let t = document.querySelector(".product__media.media.media--transparent");
            if (t) {
                let n = t.querySelector("img");
                n && (console.log("inside image"),
                n.removeAttribute("srcset"),
                n.src = e)
            }
        }
        async function ty() {
            let e = document.querySelector("script[id*='ProductJson']");
            if (e)
                return JSON.parse(e.innerHTML);
            let t = `https://${window.location.host + window.location.pathname}.json`;
            return new Promise(async (e, n) => {
                let {product: i} = await (await fetch(t)).json();
                window.ezfy_product = i,
                e(i)
            }
            )
        }
        async function tv() {
            let e = await tw();
            return e
        }
        function t$() {
            for (var e, t = [], n = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&"), i = 0; i < n.length; i++)
                e = n[i].split("="),
                t.push(e[0]),
                t[e[0]] = e[1];
            return t
        }
        async function tw() {
            let e = T;
            var t, n, i = document.querySelector(".product-form__variants");
            let s = "";
            if (null == i ? j.variantIdSelector.length > 0 && (i = document.querySelector(j.variantIdSelector)) : "div" === i.tagName.toLowerCase() && j.variantIdSelector.length > 0 && (i = document.querySelector(j.variantIdSelector)),
            null != i && (s = "input" === i.tagName.toLowerCase() ? i.value : i.selectedOptions[0].value),
            "" == s && (s = t$().variant),
            void 0 === t$().variant && "" == s) {
                let a = document.querySelectorAll("select")
                  , l = Array.prototype.filter.call(a, function(e) {
                    let t = e.getAttribute("name")
                      , n = window.getComputedStyle(e).display;
                    return "id" === t && "none" === n
                });
                s = l.length > 0 ? $(l).val() : "0"
            }
            void 0 != s && "" != s && (s = parseInt(s.trim().toLowerCase()));
            let r = e.variants.filter(e => e.id === s)[0];
            return (function e(t, n) {
                if (j?.isSetQuantity === "1") {
                    S = "https://quickstart-89a910d3.myshopify.com/cdn/shop/t/4/assets/tiles_image.webp";
                    return
                }
                if (-2 == j.imageIndex && n.images.length > 0 && (j.imageIndex = n.images.length - 1),
                void 0 != t && null != t.featured_image)
                    S = "" == t.featured_image.src ? n.featured_image : t.featured_image.src;
                else if (void 0 === t)
                    S = n.featured_image,
                    null == n.featured_image && n.images.length > 0 && j.imageIndex > -1 && (j.imageIndex < n.images.length ? S = n.images[j.imageIndex].src : n.images.length > 0 && (S = n.images[n.images.length - 1].src));
                else {
                    var i = t.image_id;
                    if (void 0 != t && null != i) {
                        if (n.images.length > 0 && j.imageIndex > -1) {
                            if (j.imageIndex < n.images.length) {
                                let s = n.images.filter(e => e.id === i)[j.imageIndex];
                                S = s.src
                            } else if (n.images.length > 0) {
                                let a = n.images.filter(e => e.id === i)[n.images.length - 1];
                                S = a.src
                            }
                        }
                    } else
                        S = n.featured_image,
                        null == n.featured_image && n.images.length > 0 && j.imageIndex > -1 && (S = j.imageIndex < n.images.length ? n.images[j.imageIndex].src : n.images[n.images.length - 1].src)
                }
                void 0 === S && (S = ""),
                -1 == S.indexOf("https:") && (S = "https:" + S)
            }(r, e),
            t = r,
            n = e,
            "1" != j.pricesFromShopify || (B = void 0 === t ? void 0 === n.price ? n.variants[0].price : n.price : t.price).toString().includes(".") || (B = function e(t, n=2) {
                if (void 0 === n || 0 == +n)
                    return Math.round(t);
                if (n = +n,
                isNaN(t = +t) || !("number" == typeof n && n % 1 == 0))
                    return NaN;
                var i = +((t = (t = Math.round(+((t = t.toString().split("e"))[0] + "e" + (t[1] ? +t[1] + n : n)))).toString().split("e"))[0] + "e" + (t[1] ? +t[1] - n : -n))
                  , s = (i = i.toFixed(2)).split(".");
                return "00" == s[1] ? s[0] : i
            }(parseFloat(B / 100))),
            void 0 == r) ? T.variants[0] : r
        }
        function t_(e) {
            return !!e && "none" !== window.getComputedStyle(e).display && "hidden" !== window.getComputedStyle(e).visibility
        }
        function tb() {
            if (t = `${j.cartWidthText} ${s.value} ${d.value} * ${j.cartHeightText} ${a.value} ${d.value}`,
            "1" == j.isMultiInputs) {
                let n = [];
                return document.querySelectorAll(".ngs-size-input").forEach(e => {
                    let t = e.value.trim();
                    t && n.push(`${t} cm`)
                }
                ),
                t = n.join(", ")
            }
            if (!0 == C)
                t = `${j.cartWidthText} ${j.sampleOrderWidth} ${d.value} * ${j.cartHeightText} ${j.sampleOrderHeight}  ${d.value}`;
            else if (e)
                t = `${j.cartWidthText} ${s.value} ${d.value} `;
            else if ("1" == j.isInchesRequired && "feet" == d.value) {
                let i = parseFloat(s.value) || 0
                  , l = parseFloat(a.value) || 0
                  , r = parseFloat(document.querySelector("#ngs-width-sub-inches").value) || 0
                  , o = parseFloat(document.querySelector("#ngs-height-sub-inches").value) || 0
                  , u = `${i}'${r.toFixed(0)}"`
                  , c = `${l}'${o.toFixed(0)}"`;
                t = `${j.cartWidthText} ${u} * ${j.cartHeightText} ${c}`
            }
            return t
        }
        async function tx() {
            let e = `${Q}get-all-settings-data?shop=${I}&productId=${T.id}`
              , t = await fetch(e);
            if (!t.ok) {
                let n = await t.json();
                throw Error(`HTTP error ${t.status}: ${n.errors}`)
            }
            return await t.json()
        }
        function tE(e, t) {
            if (e.tags) {
                let n;
                if (Array.isArray(e.tags))
                    n = e.tags;
                else {
                    if ("string" != typeof e.tags)
                        return !1;
                    n = e.tags.split(",").map(e => e.trim())
                }
                return n.includes(t)
            }
            return !1
        }
        async function tS() {
            try {
                console.log("Fetching cart data...");
                let e = await fetch("/cart.js")
                  , t = await e.json();
                return console.log("Fetched cart count:", t.item_count),
                t.item_count
            } catch (n) {
                return console.error("Error fetching cart:", n),
                0
            }
        }
        async function t9() {
            try {
                let e = await fetch("/cart.js");
                if (!e.ok)
                    throw Error("Failed to fetch cart data");
                let t = await e.json();
                return t.token
            } catch (n) {
                throw console.error("Error fetching cart token:", n),
                n
            }
        }
        T = await ty();
        let tq = await tx();
        "1" == tq.statusCode && (j = tq.SettingsData,
        D = tq.ProductSettings,
        U = tq.PresetSizes,
        e9(),
        function e() {
            let t = ".product-price__current-price";
            "graffitiwallart.myshopify.com" == I ? t = "span[data-price]" : "834cf9-4.myshopify.com" == I ? t = ".product-info__price .price__current" : "a9a8a0-3.myshopify.com" == I ? t = ".product-price" : "eurodecor-art.myshopify.com" == I && (t = ".price-item--regular");
            let n = document.querySelector(t);
            if (n) {
                let i = n.textContent.trim()
                  , s = i.match(/^[^\d\s]+|[^\d\s]+$/);
                s && (j.priceSymbol = s[0] + " ")
            }
        }(),
        e = j.isCircleProduct,
        "0" == j.pricesFromShopify && (B = parseFloat(D.unitPrice)),
        j.isImageExternal = "0",
        j.isTwoCustomSizeToggle = "0",
        "quickstart-89a910d3.myshopify.com" == I && (j.targetElementSelector = "#ProductSubmitButton-template--18612897972389__main",
        j.targetPosition = "b",
        j.isInchesRequired = "0",
        j.isShapesRequired = "0",
        j.multiMeasurementType = "d",
        j.isCustomSizeToggle = "0",
        j.isTwoCustomSizeToggle = "0",
        j.isImageExternal = "1",
        9119956304037 == T.id && (j.measurementTypes = "cm",
        j.isPopup = "1",
        j.isImageVisualiser = "0",
        j.isImageCrop = "1",
        D.tileSize = 13340,
        j.isSetQuantity = "1",
        j.filtersRequired = "0",
        j.PanelsRequired = "0",
        j.imageURL = "https://quickstart-89a910d3.myshopify.com/cdn/shop/t/4/assets/tiles_image.webp"),
        9124604838053 == T.id && (j.isPopup = "0")),
        await ts(),
        te(),
        M = await tS())
    }
});
